/*
 * Main functionality
 */

/**
 * Start and execute functions for the script, everything that needs to be executed in the start
 *
 * @param
 *
 * @return void
 */
export let __start = function () {
    /* Animated scroll swing on load page */
    if (window.location.hash) {
        setTimeout(function () {
            let hash = window.location.hash;

            if ($(hash).offset() == undefined) {
                return;
            }

            let dest = 0;
            if ($(hash).offset().top > $(document).height() - $(window).height()) {
                dest = $(document).height() - $(window).height();
            } else {
                dest = $(hash).offset().top;
            }

            $('html,body').animate({ scrollTop: dest - 100 }, 1000, 'swing');
        }, 1000);
    }
};

/**
 * Function: Searches for a links, beginning with "mailto", add a character to break the a content on small views (mobile)
 *
 * @param
 *
 * @return void
 */
export let __break_long_mail_links_words = function () {
    /* For mails */
    let mails = $('a[href^="mailto"]');
    mails.each((index, element) => {
        let get_content = $(element).text();
        let mail_array = get_content.split('');
        let at_position = get_content.indexOf('@');
        if (at_position != -1) {
            mail_array.splice(at_position, 0, '&shy;');
            let new_href = mail_array.join('');
            $(element).html(new_href);
        }
    });

    /* For website links */
    let links = $('a[href^="http://"], a[href^="https://"]');
    links.each((index, element) => {
        let link_text = $(element).text();
        if (link_text.includes('http://') || link_text.includes('https://') || link_text.includes('www.')) {
            let link_array = link_text.split('');
            link_array.splice(link_text.length / 2, 0, '&shy;');
            let new_href = link_array.join('');
            $(element).html(new_href);
        }
    });
};
/**
 * Smooth scroll effect for the whole page
 *
 * @param
 *
 * @return void
 */
export let __smooth_scroll_effect = function () {

    let lnks = document .querySelectorAll('a[href*="#"]');

    for (var i = 0; i < lnks.length; i++) {
        lnks[i].onclick = function(e){
            e.preventDefault();
            var  b = this;

            var c = b.getAttribute("href").substring(1);
            var el = document .querySelectorAll('a[name="'+c+'"]')[0];
            window.scrollTo({
                top: el.offsetTop -20,
                behavior: "smooth"
            });
        };
    }

};

/**
 * Getts the current window scroll position
 * @param
 *
 * @return string
 */
export let __get_scroll_position = async function () {
    var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0); // Viewport height (px)
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; // Current scroll position (px)
    var documentHeight = $(document).height(); // Document height (px)
    var scrollPositionRelative = scrollPosition / (documentHeight - viewportHeight); // The document height is reduced by the height of the viewport so that we reach 100% at the bottom
    return {
        documentHeight: documentHeight,
        relative: scrollPositionRelative,
        absolute: scrollPositionRelative * documentHeight, // Yields an "average" pixel position
    };
};

/**
 * Security function for mails: Crypt and uncrypt mailto links, to protect those from spam attacks
 * Example:
 * <a href="javascript:link_to_uncrypt_mailto('nbjmup;');"></a>
 * @param string s = encrypted string
 *
 * @return string
 */
let __uncrypt_mailto = function (s) {
    var n = 0;
    var r = '';
    for (var i = 0; i < s.length; i++) {
        n = s.charCodeAt(i);
        if (n >= 8364) {
            n = 128;
        }
        r += String.fromCharCode(n - 1);
    }
    return r;
};

/** Get the uncrypted mail back
 *
 * @param string s = encrypted string
 *
 * @return void
 */
let __link_to_uncrypt_mailto = function (s) {
    location.href = __uncrypt_mailto(s);
};

/** Scroll more button functionality
 *
 * @param
 *
 * @return void
 */
export let __scroll_more_button = function () {};

/** Write data to local storage
 *
 * @param string name = The name of the saved setting
 * @param string value = The value for the name
 *
 * @return void
 */
export let __write_to_local_storage = async function (name, value) {
    localStorage.setItem(name, value);
};

/** Get data to local storage
 *
 * @param string name = The name of the saved setting
 *
 * @return void
 */
export let __get_from_local_storage = async function (name) {
    let value = localStorage.getItem(name);
    return value;
};

/**
 * Function to open the fullscreen view
 *
 * @param
 *
 * @return void
 */
export let __open_fullscreen = async function () {
    let element = document.documentElement;
    if (element.requestFullscreen) {
        element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
        /* Safari */
        element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
        /* IE11 */
        element.msRequestFullscreen();
    }
};

/**
 * Function to close the fullscreen view
 *
 * @param
 *
 * @return void
 */
export let __close_fullscreen = async function () {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
    }
};

export let __load_tutorial = async function () {
    let accept_state = await __get_from_local_storage('accepttutorial');
    if (accept_state != 'true') {
        let tutorial_container = $('.tutorial--box');

        if ($(tutorial_container).length > 0) {
            $(tutorial_container).removeClass('hidden');
        }
    }
};

export let __accept_tutorial = async function () {
    let tutorial_button_selector = '.js--tutorial-button-accept';
    let tutorial_container = $(tutorial_button_selector).parentsUntil('.tutorial--box').parent();

    $(tutorial_button_selector).on('click', async function (event) {
        // Event prevent default
        event.preventDefault();

        await __write_to_local_storage('accepttutorial', 'true');

        $(tutorial_container).addClass('hidden');
    });
};

/**
 * Function called in the end, to show that the end of the file is reached
 *
 * @param
 *
 * @return void
 */
export let __end = function () {
    // Console log to show that the end of the js files is reached
    console.log(
        '%cLoaded STMNT Theme successfully',
        'background-color: #323A45; color: lightgreen; font-family: "Arial"; font-size: 14px;'
    );
};
